import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { ProjectPlanPageContext, ProjectPlanPageInitialState } from ".";

export const ProjectPlanPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ProjectPlanPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ProjectPlanPageContext.Provider value={context}>
      {children}
    </ProjectPlanPageContext.Provider>
  );
};
